import { render, staticRenderFns } from "./WorkGroupCard.vue?vue&type=template&id=9d5f5fb8&scoped=true&"
import script from "./WorkGroupCard.vue?vue&type=script&lang=js&"
export * from "./WorkGroupCard.vue?vue&type=script&lang=js&"
import style0 from "./WorkGroupCard.vue?vue&type=style&index=0&id=9d5f5fb8&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9d5f5fb8",
  null
  
)

export default component.exports